module.exports = __webpack_public_path__ + "static/img/home_c.c75930e2.png";